<!-- Main view when user is logged in -->
<template>
  <v-app>
    <UserNavBar />

    <v-main class="ma-4">
      <router-view name="users"></router-view>
    </v-main>
    <!-- <UserFooter /> -->
  </v-app>
</template>
<script>
import UserNavBar from '@/components/users/main/UserNavBar';
//import UserFooter from '@/components/users/main/UserFooter';

export default {
  data() {
    return {
      username: '',
    };
  },
  components: {
    UserNavBar,
    //  UserFooter,
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
